var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case"},[_c('div',{staticClass:"case-main"},[_c('div',{staticClass:"case-content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.details.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }